import React from 'react';
import Select from 'react-select';
import arrowIconImg from '../../../../images/arrowIcon.png'

function DetailDataTRs({ sumDs, data, isNormalUser, onChange, onChangeBool, formData }) {
    console.log(sumDs)
    const { dataClass, grpNo, indexName, indexNo, indexType, isCalc } = sumDs;
    console.log(sumDs)
    console.log(indexName);
    const boolOpt = [
        { label: 'OK', value: true },
        { label: 'NG', value: false },
    ];
    console.log(formData)
    if (Object.keys(sumDs).length === 0) return null;
    return (
        <React.Fragment>
            {
                indexName.map((innerArr, outerIdx) => {
                    return innerArr.map((indexName, innerIdx) => {
                        console.log(innerArr)
                        console.log(indexName)
                        console.log(outerIdx, innerIdx)
                        return (
                            <tr key={`data_${innerIdx}_${outerIdx}`}>
                                {
                                    innerIdx === 0
                                        ? <td className='labelTd' rowSpan={indexNo[outerIdx]}>
                                            {dataClass[outerIdx]}
                                        </td>
                                        : null
                                }
                                <td className='labelTd'>
                                    {indexName}
                                </td>
                                <td className='inputTd'>
                                    {
                                        indexType[outerIdx][innerIdx] !== 'BOOLEAN'
                                            ?
                                            isNormalUser
                                                ? `${!data[`data_${outerIdx}_${innerIdx}`] ? '-' : data[`data_${outerIdx}_${innerIdx}`]}`
                                                : <input id={`data_${outerIdx}_${innerIdx}`} name={`data_${outerIdx}_${innerIdx}`} type='number' value={formData[`data_${outerIdx}_${innerIdx}`] ?? ''} onChange={onChange} readOnly={isNormalUser} />
                                            : isNormalUser
                                                ? `${boolOpt.find(el => el.value === formData[`data_${outerIdx}_${innerIdx}`]).value}`
                                                :
                                                <div className='selectArea'>
                                                    <Select
                                                        options={boolOpt}
                                                        value={boolOpt.find(el => el.value === formData[`data_${outerIdx}_${innerIdx}`])}
                                                        onChange={sel => onChangeBool(`data_${outerIdx}_${innerIdx}`, sel)}
                                                        isSearchable={false}
                                                        classNames={{
                                                            control: (state) => 'control',
                                                            container: (state) => 'selectBox',
                                                            dropdownIndicator: (state) => 'arrow',
                                                            menu: (state) => 'options',
                                                            option: (state) => state.isSelected ? 'option selected' : state.isFocused ? 'option focused' : 'option',
                                                            singleValue: (state) => 'singleVal',
                                                            valueContainer: (state) => 'valueContainer',
                                                        }}
                                                        components={{
                                                            DropdownIndicator: (state) => <span className={state.isFocused ? 'arrowIcon focused' : 'arrowIcon'} ><img src={arrowIconImg} alt={'드롭다운'} /></span>,
                                                            IndicatorSeparator: (state) => null,
                                                        }}
                                                    />
                                                </div>


                                    }
                                </td>
                            </tr>
                        );
                    });
                })
            }
        </React.Fragment>
    );
}

export default DetailDataTRs;